// tslint:disable-next-line:variable-name
export const Breakpoints = {
    Medium: '(min-width: 960px) and (max-width: 1279px)',
    Large: '(min-width: 1280px) and (max-width: 1399px)',
    XLarge: '(min-width: 1400px)'
};
